// Contacts: the routes and the sidebar rows of `wealth.crm.contacts` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.crm.contacts',
    routes: [
        { frontend: 'desk', path: 'contacts', lazy: () => import('@/pages/desk/contacts/page') },
        {
            frontend: 'desk',
            path: 'contacts/:contactId',
            lazy: () => import('@/pages/desk/contacts/contact/page'),
        },
        { frontend: 'ops', path: 'contacts', lazy: () => import('@/pages/ops/contacts/page') },
        {
            frontend: 'ops',
            path: 'contacts/:contactId',
            lazy: () => import('@/pages/ops/contacts/contact/page'),
        },
        {
            frontend: 'comply',
            path: 'contacts',
            lazy: () => import('@/pages/comply/contacts/page'),
        },
        {
            frontend: 'comply',
            path: 'contacts/:contactId',
            lazy: () => import('@/pages/comply/contacts/contact/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'contacts',
            label: 'Contacts',
            href: '/comply/contacts',
            icon: 'Contact',
            group: 'clients-kyc',
            order: 370,
        },
        {
            frontend: 'desk',
            key: 'contacts',
            label: 'Contacts',
            href: '/desk/contacts',
            icon: 'Contact',
            group: 'septima-crm',
            order: 230,
        },
        {
            frontend: 'ops',
            key: 'contacts',
            label: 'Contacts',
            href: '/ops/contacts',
            icon: 'Contact',
            group: 'client-operations',
            order: 440,
        },
    ],
});
